import React from 'react';
import palette from '../../color-palette';

interface FavouritesProps {
  darkMode: boolean;
}

const Favourites = ({ darkMode, ...props }: FavouritesProps) => {
  const {
    primary: { main },
    common: { white },
  } = palette;

  return (
    <svg
      width="22"
      height="21"
      fill="none"
      viewBox="0 0 22 21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.1 3.18c-.06-.25-.17-.48-.25-.71A2.87 2.87 0 0 0 19.35.8c-.39-.2-.82-.28-1.24-.38a5.14 5.14 0 0 0-3.23.28 5.57 5.57 0 0 0-2.34 1.89A9.3 9.3 0 0 0 11 5.37h-.07l-.16-.36c-.1-.26-.17-.53-.29-.77a9.59 9.59 0 0 0-1.17-1.95 4.68 4.68 0 0 0-6.86-.37c-2.08 1.92-1.95 5.3-.8 7.7a23.12 23.12 0 0 0 5 6.63c.82.8 1.67 1.56 2.53 2.3.26.23 2 2 2.23 1.7l.3-.35 2.48-2.78c.62-.7 1.21-1.44 1.8-2.16.68-.82 1.37-1.63 2-2.49a22.7 22.7 0 0 0 2.24-3.8c.42-.85.78-1.71.91-2.67.13-.94.23-1.89-.04-2.82Zm-7.5 10.37c-.06.02-.16 0-.24-.01a2.47 2.47 0 0 0-.53-.03c-.38.02-.76-.01-1.18.04-.13.02-.27.02-.4.06-.5.13-1.05.19-1.58.29l-.26.04c-.35.06-.68.05-1-.12-.1-.07-.2-.14-.26-.25-.13-.06-.21-.25-.16-.38.07-.18.28-.43.43-.63a28 28 0 0 1 1.09-1.33c.1-.12.34-.35.56-.7.05-.08.26-.4.55-.72.45-.48.9-1.13.9-1.13-.14-.08-.4-.03-.53-.06-.4-.08-.74 0-1.12-.03-.44 0-.87-.02-1.3-.07-.08-.2.05-.38.1-.55.12-.37.76-.6 1.14-.64a3.7 3.7 0 0 1 1.16.06l.62.13.25.04a3.44 3.44 0 0 0 1.34-.03c.22-.07.41.22.57.35 0 .14-.11.22-.2.33-.14.18-.27.37-.38.57l-.3.4c-.22.3-.43.56-.61.92-.16.3-.42.64-.63.93-.24.33-.42.7-.67 1.06-.03.06-.09.13-.03.17.03.02.08.03.14.03.14 0 .34.01.47.04.16.03.3.03.43.07.64.16 1.27.38 1.82.73.05.1-.08.39-.18.42Z"
        fill={darkMode ? white : main}
      />
    </svg>
  );
};

export default Favourites;
